(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('orderSteps', OrderSteps)

    /** @ngInject */
    function OrderSteps(PATHS) {
        function OrderStepsController() {
            const vm = this;

            vm.setSteps = () => {
                // Set initial step
                vm.currentStep = 2;

                // Provider invoice number
                let providersWithInvoice = 0;

                vm.unit.Providers.forEach(provider => {
                    if (provider.Invoice)
                        providersWithInvoice++;
                });

                if (vm.unit.Providers.length == providersWithInvoice)
                    vm.currentStep = 3;

                // Unit collect date
                if (vm.unit.CollectSolicitationDate)
                    vm.currentStep = 4;

                if (vm.unit.CollectFinishedDate)
                    vm.currentStep = 5;
            }
        }

        function link(scope, elem, attrs, ctrl) {
            ctrl.setSteps();
        }

        return {
            bindToController: true,
            controller: OrderStepsController,
            controllerAs: 'vm',
            restrict: 'AE',
            link: link,
            templateUrl: `${PATHS.PHYSICAL}/directives/order-steps/order-steps.html`,
            scope: {
                unit: '='
            }
        }
    }
}());